import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Selection,
} from '@nextui-org/react';
import { FaAngleDown } from 'react-icons/fa6';
import Icon from '../base/Icon';
import { useAppDispatch } from '../../store/hooks';
import {
  generateAttemptedSolutions,
  generateDesiredOutcome,
  generateInterventions,
  generateProblemIdentification,
} from '../../store/chat/chatThunks';

export default function ProposeResponseDropdown() {
  const dispatch = useAppDispatch();
  const handleSelection = (keys: Selection) => {
    for (const key of keys) {
      switch (key) {
        case 'generate_problem_identification':
          dispatch(generateProblemIdentification());
          break;
        case 'generate_attempted_solutions':
          dispatch(generateAttemptedSolutions());
          break;
        case 'generate_desired_outcome':
          dispatch(generateDesiredOutcome());
          break;
        case 'generate_interventions':
          dispatch(generateInterventions());
          break;
        default:
          break;
      }
    }
  };

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button
          className="feature-dropdown"
          variant="flat"
          endContent={<Icon icon={FaAngleDown} />}
        ></Button>
      </DropdownTrigger>
      {process.env.REACT_APP_DEPLOYMENT_TYPE === 'SOS' && (
        <DropdownMenu
          aria-label="PADI dropdown"
          variant="flat"
          selectionMode="single"
          selectedKeys={undefined}
          onSelectionChange={handleSelection}
        >
          <DropdownItem key="generate_problem_identification">
            Problem Identification
          </DropdownItem>
          <DropdownItem key="generate_attempted_solutions">
            Attempted Solutions
          </DropdownItem>
          <DropdownItem key="generate_desired_outcome">
            Desired Outcome
          </DropdownItem>
          <DropdownItem key="generate_interventions">
            Interventions
          </DropdownItem>
        </DropdownMenu>
      )}
    </Dropdown>
  );
}
